import React from "react";
import AdminGeneralSettingsPage from "./AdminGeneralSettingsPage";

const AdminDistanceSalesAgreement = () => <AdminGeneralSettingsPage field="satissozlesmesi" title="Mesafeli Satış Sözleşmesi" />;

export default AdminDistanceSalesAgreement;
